module.exports = __webpack_public_path__ + "img/vipMark.03c0e3d1.png";